const general = [
  {
    size: "",
    style: "",
    class: "",
    children: [
      {
        type: "topbar",
        size: "12",
        style: "",
        class: "px-4",
        title: "General",
      },
      {
        type: "tabs",
        size: "9",
        style: "",
        class: "pr-4",
        children: [
          {
            title: "General",
            service: "category",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: false,
              activeToggle: false,
              deleteButton: false,
              updateSuccessTitle: "Category Updated!",
              updateSuccessMessage: "Category Updated Successfully!",
              updateErrorTitle: "Category Updation Failed!",
              updateErrorMessage: "Please try again!",
            },
            children: [
              {
                type: "generalCategoryTab",
                size: "12",
                style: "",
                class: "p-0",
                list: {
                  type: "list",
                  size: "4",
                  style: "",
                  class: "p-2",
                  empty: true,
                  children: [],
                },
                form: {
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style: "min-height: calc(100vh - 144px)",
                  class: "pl-3 pt-3",
                  form: {
                    enable_practice_name: {
                      type: "toggle",
                      label: "Practice Name",
                      placeholder: "",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    practice_name: {
                      type: "ckeditor",
                      label: "            ",
                      placeholder: "Enter Practice Name",
                      required: false,
                      info: false,
                      character_count: 30,
                      disabled: false,
                      class: "practice-name-category",
                      size: "12",
                      style: "",
                      displayOn: "enable_practice_name",
                      displayOnValue: "true",
                      editorConfig: {
                        toolbar: [
                          "undo",
                          "redo",
                          "fontColor", // Add the fontColor option
                        ],
                        heading: {
                          options: [
                            {
                              model: "paragraph",
                              title: "Paragraph",
                              class: "ck-heading_paragraph",
                            },
                            {
                              model: "heading1",
                              view: "h1",
                              title: "Heading 1",
                              class: "ck-heading_heading1",
                            },
                            {
                              model: "heading2",
                              view: "h2",
                              title: "Heading 2",
                              class: "ck-heading_heading2",
                            },
                            {
                              model: "heading3",
                              view: "h3",
                              title: "Heading 3",
                              class: "ck-heading_heading3",
                            },
                            {
                              model: "heading4",
                              view: "h4",
                              title: "Heading 4",
                              class: "ck-heading_heading4",
                            },
                          ],
                        },
                        fontColor: {
                          colors: [
                            {
                              color: "hsl(0, 0%, 0%)",
                              label: "Black",
                            },
                            {
                              color: "hsl(0, 0%, 30%)",
                              label: "Dim grey",
                            },
                            {
                              color: "hsl(0, 0%, 60%)",
                              label: "Grey",
                            },
                            {
                              color: "hsl(0, 0%, 90%)",
                              label: "Light grey",
                            },
                            {
                              color: "hsl(0, 0%, 100%)",
                              label: "White",
                              hasBorder: true,
                            },
                            {
                              color: "#FF5733", // Example color 1
                              label: "Logo Color 1",
                            },
                            {
                              color: "#C70039", // Example color 2
                              label: "Logo Color 2",
                            },
                            {
                              color: "#900C3F", // Example color 3
                              label: "Logo Color 3",
                            },
                            {
                              color: "#581845", // Example color 4
                              label: "Logo Color 4",
                            },
                            {
                              color: "#1C1C1C", // Example color 5
                              label: "Logo Color 5",
                            },
                            {
                              color: "#2ECC71", // Example color 6
                              label: "Logo Color 6",
                            },
                            {
                              color: "#3498DB", // Example color 7
                              label: "Logo Color 7",
                            },
                            {
                              color: "#9B59B6", // Example color 8
                              label: "Logo Color 8",
                            },
                            {
                              color: "#34495E", // Example color 9
                              label: "Logo Color 9",
                            },
                            {
                              color: "#F1C40F", // Example color 10
                              label: "Logo Color 10",
                            },
                            {
                              color: "#E67E22", // Example color 11
                              label: "Logo Color 11",
                            },
                            {
                              color: "#E74C3C", // Example color 12
                              label: "Logo Color 12",
                            },
                            {
                              color: "#ECF0F1", // Example color 13
                              label: "Logo Color 13",
                            },
                            {
                              color: "#95A5A6", // Example color 14
                              label: "Logo Color 14",
                            },
                            {
                              color: "#16A085", // Example color 15
                              label: "Logo Color 15",
                            },
                            {
                              color: "#27AE60", // Example color 16
                              label: "Logo Color 16",
                            },
                            {
                              color: "#005EB8", // Example color 17
                              label: "Logo Color 17",
                            },
                            {
                              color: "#8E44AD", // Example color 18
                              label: "Logo Color 18",
                            },
                            {
                              color: "#2C3E50", // Example color 19
                              label: "Logo Color 19",
                            },
                            {
                              color: "#BDC3C7", // Example color 20
                              label: "Logo Color 20",
                            },
                            // Add more custom colors here
                          ],
                          colorPicker: true, // Enable the custom color picker input
                        },
                        height: "100px",
                        fontSize: {
                          options: [
                            "tiny", // Equivalent to 0.7rem
                            "small", // Equivalent to 0.8rem
                            "default", // Equivalent to 1rem (usually the default size)
                            "big", // Equivalent to 1.4rem
                            "huge", // Equivalent to 1.8rem
                          ],
                          supportAllValues: true, // Allows users to enter custom font sizes if desired
                        },
                      },
                    },
                    // practice_name_color: {
                    //   type: "text",
                    //   label: "Practice Name Color",
                    //   placeholder: "Color",
                    //   required: false,
                    //   info: false,
                    //   character_count: 0,
                    //   disabled: false,
                    //   class: "",
                    //   size: "12",
                    //   style: "",
                    // },
                    hr5: {
                      type: "hr",
                      size: "12",
                    },
                    tagline: {
                      type: "toggle",
                      label: "Tagline",
                      placeholder: "",
                      required: false,
                      info: true,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    tagline_name: {
                      type: "ckeditor",
                      label: " ",
                      placeholder: "Tagline",
                      required: false,
                      displayOn: "tagline",
                      displayOnValue: "true",
                      info: false,
                      character_count: 50,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                      editorConfig: {
                        toolbar: [
                          "undo",
                          "redo",
                          "fontColor", // Add the fontColor option
                        ],
                        heading: {
                          options: [
                            {
                              model: "paragraph",
                              title: "Paragraph",
                              class: "ck-heading_paragraph",
                            },
                            {
                              model: "heading1",
                              view: "h1",
                              title: "Heading 1",
                              class: "ck-heading_heading1",
                            },
                            {
                              model: "heading2",
                              view: "h2",
                              title: "Heading 2",
                              class: "ck-heading_heading2",
                            },
                            {
                              model: "heading3",
                              view: "h3",
                              title: "Heading 3",
                              class: "ck-heading_heading3",
                            },
                            {
                              model: "heading4",
                              view: "h4",
                              title: "Heading 4",
                              class: "ck-heading_heading4",
                            },
                          ],
                        },
                        fontColor: {
                          colors: [
                            {
                              color: "hsl(0, 0%, 0%)",
                              label: "Black",
                            },
                            {
                              color: "hsl(0, 0%, 30%)",
                              label: "Dim grey",
                            },
                            {
                              color: "hsl(0, 0%, 60%)",
                              label: "Grey",
                            },
                            {
                              color: "hsl(0, 0%, 90%)",
                              label: "Light grey",
                            },
                            {
                              color: "hsl(0, 0%, 100%)",
                              label: "White",
                              hasBorder: true,
                            },
                            {
                              color: "#FF5733", // Example color 1
                              label: "Logo Color 1",
                            },
                            {
                              color: "#C70039", // Example color 2
                              label: "Logo Color 2",
                            },
                            {
                              color: "#900C3F", // Example color 3
                              label: "Logo Color 3",
                            },
                            {
                              color: "#581845", // Example color 4
                              label: "Logo Color 4",
                            },
                            {
                              color: "#1C1C1C", // Example color 5
                              label: "Logo Color 5",
                            },
                            {
                              color: "#2ECC71", // Example color 6
                              label: "Logo Color 6",
                            },
                            {
                              color: "#3498DB", // Example color 7
                              label: "Logo Color 7",
                            },
                            {
                              color: "#9B59B6", // Example color 8
                              label: "Logo Color 8",
                            },
                            {
                              color: "#34495E", // Example color 9
                              label: "Logo Color 9",
                            },
                            {
                              color: "#F1C40F", // Example color 10
                              label: "Logo Color 10",
                            },
                            {
                              color: "#E67E22", // Example color 11
                              label: "Logo Color 11",
                            },
                            {
                              color: "#E74C3C", // Example color 12
                              label: "Logo Color 12",
                            },
                            {
                              color: "#ECF0F1", // Example color 13
                              label: "Logo Color 13",
                            },
                            {
                              color: "#95A5A6", // Example color 14
                              label: "Logo Color 14",
                            },
                            {
                              color: "#16A085", // Example color 15
                              label: "Logo Color 15",
                            },
                            {
                              color: "#27AE60", // Example color 16
                              label: "Logo Color 16",
                            },
                            {
                              color: "#005EB8", // Example color 17
                              label: "Logo Color 17",
                            },
                            {
                              color: "#8E44AD", // Example color 18
                              label: "Logo Color 18",
                            },
                            {
                              color: "#2C3E50", // Example color 19
                              label: "Logo Color 19",
                            },
                            {
                              color: "#BDC3C7", // Example color 20
                              label: "Logo Color 20",
                            },
                            // Add more custom colors here
                          ],
                          colorPicker: true, // Enable the custom color picker input
                        },
                        height: "100px",
                        fontSize: {
                          options: [
                            "tiny", // Equivalent to 0.7rem
                            "small", // Equivalent to 0.8rem
                            "default", // Equivalent to 1rem (usually the default size)
                            "big", // Equivalent to 1.4rem
                            "huge", // Equivalent to 1.8rem
                          ],
                          supportAllValues: true, // Allows users to enter custom font sizes if desired
                        },
                      },
                    },
                    // tagline_name_color: {
                    //   type: "text",
                    //   label: "Tagline Color",
                    //   placeholder: "color",
                    //   required: false,
                    //   displayOn: "tagline",
                    //   displayOnValue: "true",
                    //   info: false,
                    //   disabled: false,
                    //   class: "",
                    //   size: "12",
                    //   style: "",
                    // },
                    hr1: {
                      type: "hr",
                      size: "12",
                    },
                    practice_logo: {
                      type: "toggle",
                      label: "Practice Logo",
                      placeholder: "",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    cqc_rating: {
                      type: "toggle",
                      label: "CQC Rating",
                      placeholder: "",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    logo_url: {
                      type: "imgSelect",
                      label: "       ",
                      hideLabel: true,
                      placeholder: "Select Image",
                      load_url: "",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                      displayOn: "practice_logo",
                      displayOnValue: "true",
                    },
                    gutter1: {
                      type: "gutter",
                      size: "6",
                      displayOn: "cqc_rating",
                      displayOnValue: "false",
                    },
                    gutter2: {
                      type: "gutter",
                      size: "6",
                      displayOn: "practice_logo",
                      displayOnValue: "false",
                    },
                    // cqc_url: {
                    //   type: "select",
                    //   label: "CQC Rating url",
                    //   placeholder: "Select",
                    //   required: false,
                    //   info: false,
                    //   character_count: 0,
                    //   disabled: false,
                    //   class: "",
                    //   size: "6",
                    //   style: "",
                    //   options: ["Outstanding"],
                    // },
                    cqc_option: {
                      type: "select",
                      label: "         ",
                      // hideLabel: true,
                      placeholder: "Select",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                      options: [
                        "Outstanding",
                        "Good",
                        "Requires improvement",
                        "Inadequate",
                        "Not rated"
                      ],
                      displayOn: "cqc_rating",
                      displayOnValue: "true",
                    },
                    gutter3: {
                      type: "gutter",
                      size: "6",
                      displayOn: "practice_logo",
                      displayOnValue: "false",
                    },
                    practice_logo_preview: {
                      type: "imgPreview",
                      label: "image preview",
                      hideLabel: true,
                      placeholder: "",
                      displayOn: "practice_logo",
                      displayOnValue: "true",
                      displayURL: "logo_url",
                      load_url: "",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "mT-50",
                      size: "6",
                      style: "",
                    },
                    cqc_preview: {
                      type: "imgPreview",
                      label: "CQC Rating Preview",
                      hideLabel: true,
                      placeholder: "",
                      displayOn: "cqc_rating",
                      displayOnValue: "true",
                      displayURL: "cqc_option",
                      load_url: "",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "mT-50",
                      size: "6",
                      style: "",
                    },
                    // hr23: {
                    //   type: "hr",
                    //   size: "12",
                    // },
                    // cqc_rating: {
                    //   type: "toggle",
                    //   label: "CQC Rating",
                    //   placeholder: "",
                    //   required: false,
                    //   info: true,
                    //   character_count: 0,
                    //   disabled: false,
                    //   class: "",
                    //   size: "12",
                    //   style: "",
                    // },
                    // cqc_url: {
                    //   type: "imgSelect",
                    //   label: "  ",
                    //   hideLabel: true,
                    //   placeholder: "Select Image",
                    //   load_url: "",
                    //   required: false,
                    //   info: false,
                    //   character_count: 0,
                    //   disabled: false,
                    //   class: "",
                    //   size: "6",
                    //   style: "",
                    //   displayOn: "cqc_rating",
                    //   displayOnValue: "true",
                    // },
                    // cqc_preview: {
                    //   type: "imgPreview",
                    //   label: "cqc image preview",
                    //   hideLabel: true,
                    //   placeholder: "",
                    //   displayOn: "cqc_rating",
                    //   displayOnValue: "true",
                    //   displayURL: "cqc_url",
                    //   load_url: "",
                    //   required: false,
                    //   info: false,
                    //   character_count: 0,
                    //   disabled: false,
                    //   class: "mT-50",
                    //   size: "6",
                    //   style: "",
                    // },
                    hr2: {
                      type: "hr",
                      size: "12",
                    },
                    // occupation_check: {
                    //   type: "checkbox",
                    //   label: "Mandatory Field Settings",
                    //   placeholder: "Occupation",
                    //   required: false,
                    //   info: false,
                    //   character_count: 0,
                    //   disabled: false,
                    //   class: "",
                    //   size: "12",
                    //   style: "",
                    // },
                    nhs_logo: {
                      type: "checkbox",
                      label: "Features",
                      placeholder: "NHS Logo",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "form-container-1",
                      size: "12",
                      style: "",
                    },
                    join_us: {
                      type: "checkbox",
                      label: "Join Us Button",
                      placeholder: "Join Us Button",
                      required: false,
                      info: true,
                      hideLabel: true,
                      character_count: 0,
                      disabled: false,
                      class: "form-container-1",
                      size: "12",
                      style: "",
                    },
                    feedback_widget: {
                      type: "checkbox",
                      label: "Feedback widget",
                      hideLabel: true,
                      placeholder: "Feedback Widget",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "form-container-1",
                      size: "12",
                      style: "",
                    },
                    search: {
                      type: "checkbox",
                      label: "Search",
                      hideLabel: true,
                      placeholder: "Search",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "form-container-1",
                      size: "12",
                      style: "",
                    },
                    accessibility_widget: {
                      type: "checkbox",
                      hideLabel: true,
                      label: "Accessibility Widget",
                      placeholder: "Accessibility Widget",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "form-container-1",
                      size: "12",
                      style: "",
                    },
                    hr3: {
                      type: "hr",
                      size: "12",
                    },
                    contact: {
                      type: "toggle",
                      label: "Contacts",
                      placeholder: "",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    contact_input: {
                      type: "contactinput",
                      label: "",
                      placeholder: "",
                      required: false,
                      info: false,
                      character_count: 0,
                      displayOn: "contact",
                      displayOnValue: "true",
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr4: {
                      type: "hr",
                      size: "12",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
        ],
      },
    ],
  },
];

export { general };
